(function () {
  function setOpen(detailsEl, isOpen) {
    if (!detailsEl) return;

    // native <details>
    if (isOpen) detailsEl.setAttribute('open', '');
    else detailsEl.removeAttribute('open');

    // if your theme uses a JS property too
    try { detailsEl.open = isOpen; } catch (e) {}

    // aria-expanded on summary
    const summary = detailsEl.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', String(isOpen));
  }

  function toggle(detailsEl) {
    const isOpen =
      detailsEl.hasAttribute('open') ||
      detailsEl.getAttribute('open') === '' ||
      detailsEl.open === true;

    setOpen(detailsEl, !isOpen);
    return !isOpen;
  }

  function focusFirstItem(detailsEl) {
    const first = detailsEl.querySelector(
      '.dropdown a, .dropdown button, .dropdown [tabindex]:not([tabindex="-1"])'
    );
    if (first) first.focus();
  }

  document.addEventListener('keydown', (event) => {
    // Find the summary the key event is coming from (works even if focus is on <magnet-element>)
    const summary = event.target.closest('summary[data-link]');
    if (!summary) return;

    const detailsEl = summary.closest('details');
    if (!detailsEl) return;

    const key = event.key;

    // Enter = follow the "link"
    if (key === 'Enter') {
      const href = summary.getAttribute('data-link');
      if (href) {
        event.preventDefault();
        event.stopPropagation();
        window.location.assign(href);
      }
      return;
    }

    // Space or ArrowDown = toggle/open dropdown
    if (key === ' ' || key === 'Spacebar' || key === 'ArrowDown') {
      event.preventDefault();
      event.stopPropagation();

      const isNowOpen = toggle(detailsEl);

      // Optional: when opening with ArrowDown (or Space), move focus into the menu
      if (isNowOpen) focusFirstItem(detailsEl);
      return;
    }

    // If your theme already handles Escape, you can omit this.
    // Keeping it here doesn't hurt (it just closes the nearest details).
    if (key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      setOpen(detailsEl, false);
      summary.focus();
    }
  }, true); // <-- capture phase: catches events even if something stops propagation
})();